<template>
  <transition
    v-if="$slots.default"
    name="pop"
    appear
  >
    <section class="pop">
      <slot />
    </section>
  </transition>
</template>

<script>
import smoothReflow from "vue-smooth-reflow";

export default {
  name: "PopOverContainer",

  mixins: [smoothReflow],

  mounted() {
    this.$smoothReflow({
      property: ["width"],
      transition: "width .3s ease-out",
    });

    this.focusableElementsSetup();
  },

  updated() {
    this.focusableElementsSetup();
  },

  methods: {
    // prettier-ignore
    // this will auto focus the mouse cursor everytime the popover opens
    focusableElementsSetup() {
      // list of possible focusable elements
      const focusableElements = "button, a, [href], input, select, textarea, [tabindex]:not([tabindex=\"-1\"])";

      function trapFocus(selector) {
        // select the popover by it's CSS selector
        const popover = document.querySelector(selector);

        if (popover) {
          const focusableContent = popover?.querySelectorAll(focusableElements);
          const firstFocusableElement = popover.querySelectorAll(focusableElements)[0]; // get first element to be focused inside modal
          const lastFocusableElement = focusableContent[focusableContent.length - 1]; // get last element to be focused inside modal

          document.addEventListener("keydown", function (e) {
            const isTabPressed = e.key === "Tab" || e.keyCode === 9;

            if (!isTabPressed) return;

            if (e.shiftKey) {
              // if shift key pressed for shift + tab combination
              if (document.activeElement === firstFocusableElement) {
                lastFocusableElement.focus(); // add focus for the last focusable element
                e.preventDefault();
              }
            } else {
              // if tab key is pressed
              if (document.activeElement === lastFocusableElement) {
                // if focused has reached to last focusable element then focus first focusable element after pressing tab
                firstFocusableElement.focus(); // add focus for the first focusable element
                e.preventDefault();
              }
            }
          });

          firstFocusableElement.focus();
        }
      }

      trapFocus(".pop");
    },
  },
};
</script>
